import {isSuccessfulCall, ServiceCall} from "./ServiceCall";
import {ServiceRoutes, ServiceVersions} from "./ApiEnums";
import {GenericErrorCaller, GenericErrorCallerForCatch, handleError} from "../components/sweetAlert/GenericAlerts";
import CustomAlert from "../components/customAlert/CustomAlert";

interface IParametersResetPassword {
    email:string;
}
interface IResponseResetPassword {
    result_code:number;
    data:{
        forward_to:boolean;
    }
}

export function ApiResetPassword(
    email : string
): Promise<string>{

    return new Promise((resolve, reject)=>{

        const parameters : IParametersResetPassword = {
            email : email
        };

        ServiceCall('POST', ServiceRoutes.ResetPassword, parameters, ServiceVersions.v10).then((response:any)=>{

            const result : IResponseResetPassword = response.data;

            if(isSuccessfulCall(result)){
                resolve(response.data.error_detail_message);
            }else{
                handleError(result);
            }

        }, (response: any) => {
            handleError(response);

        }).catch((error: any)=>{
            handleError(error);
        });

    });

}



interface IParametersChangeForgottenPassword {
    email:string;
    newpassword:string;
    auth_code:string;
}
interface IResponseChangeForgottenPassword {
    result_code:number;
    data:{
        forward_to:boolean;
    }
}

export function ApiChangeForgottenPassword(
    email: string,
    newPassword: string,
    authCode: string
){

    return new Promise((resolve,reject)=>{

        const parameters : IParametersChangeForgottenPassword = {
            email: email,
            newpassword : newPassword,
            auth_code : authCode
        };

        ServiceCall('PUT',ServiceRoutes.ChangeForgottenPassword, parameters, ServiceVersions.v10).then((response:any)=>{

            const result : IResponseChangeForgottenPassword = response.data;

            if(isSuccessfulCall(result)){
                resolve(response.data.error_detail_message);
            }else{
                handleError(result);
            }

        }, (response: any) => {
            handleError(response);

        }).catch((error:any)=>{
            handleError(error);
        });

    });

}

